<template>
    <v-app>
        <v-main style="align-items:center">
            <v-container
                fluid
            >
            <div>
                <div>
                    Service Unavilable
                </div>
                <div>
                    DEBUGGING
                </div> 
                <div>
                    {{ $route.params }}
                </div>
            </div>
            </v-container>
        </v-main>
    </v-app>

</template>

<script>
export default {
    mounted : function () {
        this.$store.commit('clearLoading')
    },
}
</script>

